import Vue from "vue";
import VueMatomo from "vue-matomo"; // 访问量所需插件
// import App from "./App.vue";
// import router from "./router";
// import store from "./store";
import { addUrlPerFix } from "@/utils";
import "babel-polyfill";
import shopTypeMap from "@/mixins/shop-type-map";

(function() {
  Object.setPrototypeOf =
    Object.setPrototypeOf ||
    ({
      __proto__: []
    } instanceof Array
      ? setProtoOf
      : mixinProperties);

  function setProtoOf(obj, proto) {
    obj.__proto__ = proto;
    return obj;
  }

  function mixinProperties(obj, proto) {
    for (const prop in proto) {
      if (!obj.hasOwnProperty(prop)) {
        obj[prop] = proto[prop];
      }
    }
    return obj;
  }
})();

// 引入element组件库
import {
  Table,
  TableColumn,
  // Pagination,
  Tooltip,
  Tree,
  Input,
  Aside
} from "element-ui";

// 引入交建组件库
import {
  InputNumber, // 引入计数器
  Dialog,
  Autocomplete,
  Menu,
  MenuItem,
  PlainOrgSelector,
  PlainSearch,
  TopNavMenu,
  Scrollbar,
  TimelineApproval,
  Submenu,
  Col,
  CardTitle,
  Row,
  Progress,
  Card,
  Tag,
  DataCard,
  Timeline,
  TimelineItem,
  Button,
  Alert,
  Popover,
  CheckboxGroup,
  Checkbox,
  Pagination,
  Label,
  TimeoutLogin,
  Loading,
  Breadcrumb,
  BreadcrumbItem,
  HistoryList,
  Form,
  FormItem,
  BottomPrintExport,
  TagSelector,
  Select,
  Option,
  Message,
  Search,
  TopNavMenu2,
  TopNavMenu3,
  TopNavMenu4,
  MerchantSelector,
  DatePicker,
  InputTagDatePicker,
  DetailInfo,
  Radio,
  RadioButton,
  RadioGroup,
  SimpleFooter,
  EmpFooter,
  TreeSelector,
  AdvancedDatePicker,
  StatisticsCard,
  Tabs,
  TabPane,
  Switch,
  Image,
  SwitchComponent,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  BottomGuide,
  MessageBox,
  Cascader,
  ExportButton,
  Upload,
  ButtonGroup,
  AreaSelector
} from "ccui";

import tableList from "./common/table-list";

import "ccui/lib/theme-chalk/index.css"; // CCUI样式
// import MessageBox from "ccui/lib/message-box";
import tips from "./common/zh-ch";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./permission"; // permission control

// import "./mock"; // mock数据
import "./icons"; // SVG
import "./assets/font/icon-ccui.css";

import "@/styles/index.scss"; // global css
// import { isSupportExplore, isSupportIEVersion } from "@/utils";

import * as filters from "./filters"; // global filters
import functions from "./utils/functions"; // global filters

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

// 注册全局组件
Vue.prototype.$dialog = Dialog;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.tableList = tableList;
Vue.prototype.tips = tips;
// 注册全局方法
Vue.use(functions);
// 注册项目中用到的组件
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Tooltip);
Vue.use(Tree);
Vue.use(Input);
Vue.use(Aside);

// 注册CCUI的组件
Vue.use(InputNumber);
Vue.use(TimeoutLogin);
Vue.use(PlainOrgSelector);
Vue.use(CardTitle);
Vue.use(TimelineApproval);
Vue.use(TopNavMenu);
Vue.use(MenuItem);
Vue.use(HistoryList);
Vue.use(Menu);
Vue.use(Scrollbar);
Vue.use(Submenu);
Vue.use(Timeline);
Vue.use(Autocomplete);
Vue.use(TimelineItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Label);
Vue.use(Loading);
Vue.use(PlainSearch);
Vue.use(Progress);
Vue.use(Card);
Vue.use(Tag);
Vue.use(BottomPrintExport);
Vue.use(DataCard);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Alert);
Vue.use(Button);
Vue.use(Popover);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(TagSelector);
Vue.use(Select);
Vue.use(Option);
Vue.use(Search);
Vue.use(TopNavMenu2);
Vue.use(TopNavMenu3);
Vue.use(TopNavMenu4);
Vue.use(MerchantSelector);
Vue.use(DatePicker);
Vue.use(InputTagDatePicker);
Vue.use(DetailInfo);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(SimpleFooter);
Vue.use(EmpFooter);
Vue.use(TreeSelector);
Vue.use(StatisticsCard);
Vue.use(AdvancedDatePicker);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Switch);
Vue.use(Image);
Vue.use(SwitchComponent);
Vue.use(DropdownMenu);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(BottomGuide);
Vue.use(Cascader);
Vue.use(ExportButton);
Vue.use(Upload);
Vue.use(ButtonGroup);
Vue.use(AreaSelector);
Vue.mixin(shopTypeMap);

Vue.use(VueMatomo, {
  host: addUrlPerFix(process.env.VUE_APP_VUEMATOMO_HOST), // 这里配置你自己的piwik服务器地址和网站ID
  siteId: 22, //siteId值
  // 根据router自动注册
  router: router,
  // // 是否需要在发送追踪信息之前请求许可
  // // 默认false
  requireConsent: false,
  enableLinkTracking: true,
  // // 是否追踪初始页面
  // // 默认true
  trackInitialView: false,
  // // 最终的追踪js文件名
  // // 默认 'piwik'
  trackerFileName: "matomo",
  debug: false
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
